import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import EducationEdit from './EducationEdit';

const Education = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={24} 
                        md={24} 
                        options={props.ad.EXAM_CODE} 
                        type="Select" 
                        name="exam name" 
                        value={data.exam_code} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="school" 
                        value={data.school_name} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="university or board" 
                        value={data.exam_board} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="year of passing" 
                        value={data.pass_year} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="marks" 
                        value={data.marks} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={24} 
                        md={24} 
                        name="subjects" 
                        value={data.subjects} 
                    />
                </Row>  
                <p></p>
            </div>
            
            );
        })
           
        :
        <>
            <p></p>
            <EducationEdit examOptions = {props.ad.EXAM_CODE} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Education